module.exports = __webpack_public_path__ + "static/media/IL.a4b99bee.png";